<template>
  <div class="message-board-container" id="aochenBoard1">
    <Separate title="投诉举报" desc="COMPLAINT AND REPORT"></Separate>
    <div class="message-board-container-content">
      <el-form ref="form" :model="form" label-width="80px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="联系方式">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="举报内容">
              <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="form.memo" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-button type="danger" @click="handleSubmit" style="width: 600px">提交</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import Separate from '@/components/Separate/index'
import { siteLeaveAdd } from '@/api/report'

export default {
  name: 'MessageBoard',
  components: { Separate },
  data() {
    return {
      form: {
        linkUser: undefined,
        phone: undefined,
        memo: undefined
      }
    }
  },
  methods: {
    handleSubmit() {
      siteLeaveAdd(this.form).then(({ data }) => {
        this.$message.success('提交成功，后续我们会根据您的意见给予您反馈！')
        this.form = {
          linkUser: undefined,
          phone: undefined,
          memo: undefined
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.message-board-container {
  width: $content-width;
  padding-bottom: 15px;
}
</style>
